import { create } from "zustand";
import {
  findAllTipologias,
  findAllModalidades,
  findAllModalidadesAcao,
  findAllTemas,
} from "API/apiAcoes";
import { convertListSelect } from "utils/Arrays";
import { Modalidade, TemaTurma, Tipologia } from "types/acao";

interface ComplementoAcaoState {
  msgError: string | null;
  loadingComplementos: boolean;
  complementosCarregados: boolean;
  complementosResolvidos: boolean;
  tipologias: Tipologia[];
  modalidades: Modalidade[];
  modalidadesAcao: Modalidade[];
  temas: TemaTurma[];
  carregarComplementos: (force?: boolean) => Promise<void>;
  clearAll: () => void;
}

let complementoAcaoPromise: Promise<void> | null = null;

export const useComplementoAcaoStore = create<ComplementoAcaoState>((set, get) => ({
  msgError: null,
  loadingComplementos: false,
  complementosCarregados: false,
  complementosResolvidos: false,
  tipologias: [],
  modalidades: [],
  modalidadesAcao: [],
  temas: [],

  carregarComplementos: async (force = false) => {
    if (!force && get().complementosCarregados) {
      return;
    }

    if (get().loadingComplementos && complementoAcaoPromise) {
      await complementoAcaoPromise;
      return;
    }

    set({ loadingComplementos: true, msgError: null });

    complementoAcaoPromise = (async () => {
      try {
        const [tipologias, modalidades, modalidadesAcao, temas] = await Promise.all([
          findAllTipologias(),
          findAllModalidades(),
          findAllModalidadesAcao(),
          findAllTemas(),
        ]);

        set({
          tipologias: convertListSelect(tipologias, "id", "nome"),
          modalidades: convertListSelect(modalidades, "id", "nome"),
          modalidadesAcao: convertListSelect(modalidadesAcao, "id", "nome"),
          temas: convertListSelect(temas, "id", "nome"),
          complementosCarregados: true,
        });
      } catch (error) {
        set({
          msgError: "Nao foi possivel carregar os complementos da acao",
          complementosCarregados: false,
        });
      } finally {
        set({ loadingComplementos: false, complementosResolvidos: true });
        complementoAcaoPromise = null;
      }
    })();

    await complementoAcaoPromise;
  },

  clearAll: () =>
    set({
      msgError: null,
      loadingComplementos: false,
      complementosCarregados: false,
      complementosResolvidos: false,
      tipologias: [],
      modalidades: [],
      modalidadesAcao: [],
      temas: [],
    }),
}));
